function normalizeFetchBaseUrl(url: string): string {
  const trimmed = url.trim().replace(/\/+$/, '');

  // LiveKit URLs are often ws/wss; auth endpoints are fetched over http/https.
  if (trimmed.startsWith('wss://')) {
    return `https://${trimmed.slice('wss://'.length)}`;
  }
  if (trimmed.startsWith('ws://')) {
    return `http://${trimmed.slice('ws://'.length)}`;
  }

  return trimmed;
}

export function getAuthBaseUrl(): string {
  const authBaseUrl = process.env.NEXT_PUBLIC_AUTH_BASE_URL?.trim();

  if (!authBaseUrl) {
    throw new Error(
      'Auth base URL is not set. Configure NEXT_PUBLIC_AUTH_BASE_URL/NEXT_PUBLIC_AUTH_BASE_URL_LOCAL or LIVEKIT_URL/LIVEKIT_URL_LOCAL.',
    );
  }

  return normalizeFetchBaseUrl(authBaseUrl);
}
